import { SupportChat } from "./support-chat";

// Upwex runs its own support chat. Intercom has been removed entirely.
export const LiveChat = (): JSX.Element | null => {
  return <SupportChat />;
};
